<template>
  <div class="filter-bar z-index-2">
    <!-- 筛选条件区域 -->
    <div class="filter-bar-selects">
      <div class="filter-bar-select">
        <span>设备型号</span>
        <el-select
          v-model="deviceModel"
          placeholder="请选择"
          clearable
          @change="onDeviceModelChange"
        >
          <el-option
            v-for="item in deviceModelList"
            :key="item.value"
            :label="item.label"
            :value="item.label"
          >
          </el-option>
        </el-select>
      </div>
      
      <div class="filter-bar-select">
        <span>设备SN</span>
        <el-input
          v-model="deviceSN"
          placeholder="请输入设备SN"
          clearable
          @input="onDeviceSNChange"
        >
        </el-input>
      </div>

      <div class="filter-bar-select">
        <span>设备性质</span>
        <el-select
          v-model="deviceNature"
          placeholder="请选择"
          clearable
          @change="onDeviceNatureChange"
        >
          <el-option
            v-for="item in deviceNatureList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>

      <div class="filter-bar-select">
        <span>设备属性</span>
        <el-select
          v-model="deviceAttribute"
          placeholder="请选择"
          clearable
          @change="onDeviceAttributeChange"
        >
          <el-option
            v-for="item in deviceAttributeList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      
      <div class="filter-bar-select">
        <span>设备状态</span>
        <el-cascader
          v-model="deviceStatusValue"
          :options="deviceStatusOptions"
          placeholder="请选择"
          clearable
          :show-all-levels="false"
          :change-on-select="true"
          @change="onDeviceStatusChange"
        >
        </el-cascader>
      </div>
      
      <div class="filter-bar-select">
        <span>负责人</span>
        <el-select
          v-model="responsiblePerson"
          placeholder="请选择"
          filterable
          clearable
          @change="onResponsiblePersonChange"
        >
          <el-option
            v-for="item in responsiblePersonList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      
      <div class="filter-bar-select">
        <span>机构</span>
        <el-select
          v-model="organization"
          placeholder="请选择"
          clearable
          filterable
          remote
          :remote-method="remoteSearchOrganization"
          :loading="organizationLoading"
          @change="onOrganizationChange"
          
        >
          <el-option
            v-for="item in filteredOrganizationList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      
      <div class="filter-bar-select">
        <span>流量卡</span>
        <el-select
          v-model="flowCard"
          placeholder="请选择"
          clearable
          @change="onFlowCardChange"
        >
          <el-option
            v-for="item in flowCardList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
   
     
    </div>
    
    <!-- 按钮区域 -->
    <div class="filter-bar-buttons">
      <button
        class="filter-bar-button"
        @click="search"
      >
        搜索
      </button>
      <button
        class="filter-bar-button"
        @click="exportAction"
      >
        导出
      </button>
    </div>
  </div>
</template>

<script>
import BarPicker from "@c/operation-log/common/bar-picker.vue";
import KeywordSearch from "@c/operation-log/common/filter-bar/keyword-search.vue";
import { Select, Option, Input, Button, Cascader } from "element-ui";

export default {
  components: {
    BarPicker,
    KeywordSearch,
    ElSelect: Select,
    ELOption: Option,
    ElInput: Input,
    ElButton: Button,
    ElCascader: Cascader,
  },

  model: {
    prop: "keyword",
    event: "onSearchClick",
  },

  props: {
    initialSelectedIndex: {
      type: Number,
      default: 0,
    },
    itemArray: Array,
    //有否按钮
    buttonTitle: {
      type: String,
      default: null,
    },
    //有否日期选择器
    hasDatePicker: {
      type: Boolean,
      default: false,
    },
    initDuration: {
      type: Array,
      required: false,
    },
    //有否关键词搜索栏
    keywordTitle: {
      type: String,
      default: null,
    },
    keyword: {
      type: String,
      default: "",
    },
    showPushStatus: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      currentIndex: 0,
      keywordTemp: "",
      duration: undefined,
      pushStatus: undefined,
      pushStatusList: window.PUSH_LOG_STATUS_TYPE,
      // 新增的筛选字段
      deviceModel: undefined,
      deviceSN: undefined,
      deviceAttribute: undefined,
      deviceStatus: undefined,
      faultOrderStatus: undefined,
      deviceStatusValue: [],
      responsiblePerson: undefined,
      organization: undefined,
      flowCard: undefined,
      deviceNature: undefined,
      deviceAttribute: undefined,
      // 下拉框数据源
      deviceModelList: [],
      deviceAttributeList: [
        { value: 0, label: '默认' },
        { value: 1, label: '正式进院' },
        { value: 2, label: '试用' }
      ],
      deviceStatusOptions: [
        { value: 1, label: '在库' },
        { value: 2, label: '已售' },
        { value: 3, label: '流转中' },
        {
          value: 4,
          label: '故障维修',
          children: [
            { value: 1, label: '已提交' },
            { value: 2, label: '维修中' }
          ]
        },
        { value: 5, label: '废弃' },
        { value: 6, label: '丢失' },
      ],
      responsiblePersonList: [],
      organizationList: [],
      filteredOrganizationList: [],
      organizationLoading: false,
      flowCardList: [
        { value: 1, label: '最近一个月到期' },
        { value: 2, label: '已超流量' },
        { value: 3, label: '停用' },
        { value: 4, label: '超期' },
        { value: 5, label: '流量为0' },
      ],
      deviceNatureList: [
        { value: 1, label: '新设备' },
        { value: 2, label: '流转设备' }
      ],
    };
  },

  computed: {
    // 权限判断：只有高级系统管理员可以进行设备入库
    isSeniorAdministrator() {
      return this.$store.getters.isSeniorAdministrator;
    },
  },

  watch: {
    initialSelectedIndex(value) {
      this.currentIndex = value;
    },

    initDuration(value) {
      this.duration = value;
    },

    keyword(value) {
      this.keywordTemp = value;
    },
  },

  created() {
    this.currentIndex = this.initialSelectedIndex;
    this.keywordTemp = this.keyword;
  },

  async mounted() {
    await this.getDeviceTypesList();
    await this.getHospitalList();
    await this.getResponsiblePersonList();
  },

  methods: {
    onItemSelected(index) {
      this.currentIndex = index;
      this.$emit("onItemSelected", this.currentIndex);
    },

    onSearchClick(value) {
      this.$emit("onSearchClick", value);
    },

    onButtonClick() {
      this.$emit("onButtonClick");
    },

    onDurationSelected() {
      this.$emit("onDurationSelected", this.duration);
    },

    onPushStatusChange() {
      this.$emit("onPushStatusChange", this.pushStatus);
    },
    
    // 新增的事件处理方法
    onDeviceModelChange() {
      this.$emit("onDeviceModelChange", this.deviceModel);
    },
    
    onDeviceSNChange() {
      this.$emit("onDeviceSNChange", this.deviceSN);
    },

    onDeviceAttributeChange() {
      this.$emit("onDeviceAttributeChange", this.deviceAttribute);
    },
    
    onDeviceStatusChange(value) {
      if (value && value.length > 0) {
        this.deviceStatus = value[0];
        // 只有当选择了故障维修的子级时，才设置 faultOrderStatus
        if (value[0] === 4 && value.length > 1) {
          this.faultOrderStatus = value[1];
        } else {
          this.faultOrderStatus = undefined;
        }
      } else {
        this.deviceStatus = undefined;
        this.faultOrderStatus = undefined;
      }
      
      console.log('选中的值:', value);
      console.log('deviceStatus:', this.deviceStatus);
      console.log('faultOrderStatus:', this.faultOrderStatus);
      
      this.$emit("onDeviceStatusChange", {
        deviceStatus: this.deviceStatus,
        faultOrderStatus: this.faultOrderStatus
      });
    },
    
    onResponsiblePersonChange() {
      this.$emit("onResponsiblePersonChange", this.responsiblePerson);
    },
    
    onOrganizationChange() {
      this.$emit("onOrganizationChange", this.organization);
    },
    
    onFlowCardChange() {
      this.$emit("onFlowCardChange", this.flowCard);
    },
    
    onDeviceNatureChange() {
      this.$emit("onDeviceNatureChange", this.deviceNature);
    },
    
    // 获取设备型号列表
    async getDeviceTypesList() {
      const params={}
      try {
        const response = await this.$api.getDeviceTypesList(params);
        this.deviceModelList = response.map(item => ({
          value: item.id,
          label: item.model
        }));
      } catch (error) {
        console.error('获取设备型号列表失败:', error);
      }
    },
    
    // 获取机构列表
    async getHospitalList() {
      try {
        const params = {
          parentId: this.$store.state.accountInfo.id
        };
        const response = await this.$api.getHospitalList(params);
        
        const rawDataArray = response.map((item) => {
          return {
            value: item.id,
            label: item.hospitalName
          };
        });
        this.organizationList = [{ value: null, label: "全部" },{ value: 0, label: "无机构" }].concat(rawDataArray);
        // 初始化显示前20个项目
        this.filteredOrganizationList = this.organizationList.slice(0, 20);
      } catch (error) {
        console.error('获取机构列表失败:', error);
      }
    },
    
    // 获取负责人列表
    async getResponsiblePersonList() {
      try {
        const response = await this.$api.getResponsiblePersonList();
        this.responsiblePersonList = response.map(item => ({
          value: item.id,
          label: item.trueName
        }));
      } catch (error) {
        console.error('获取负责人列表失败:', error);
      }
    },
    
    // 机构远程搜索
    remoteSearchOrganization(query) {
      if (query !== '') {
        this.organizationLoading = true;
        setTimeout(() => {
          this.organizationLoading = false;
          this.filteredOrganizationList = this.organizationList.filter(item => {
            return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
          });
        }, 200);
      } else {
        // 无搜索关键词时显示前20个
        this.filteredOrganizationList = this.organizationList.slice(0, 20);
      }
    },
    
    // 搜索方法：收集所有筛选条件并传给父组件
    search() {
      const searchConditions = {
        model: this.deviceModel,
        deviceSn: this.deviceSN,
        deviceAttribute: this.deviceAttribute,
        deviceStatus: this.deviceStatus,
        faultOrderStatus: this.faultOrderStatus,
        outboundPersonId: this.responsiblePerson,
        outboundHospitalId: this.organization,
        expirationStatus: this.flowCard,
        deviceNature: this.deviceNature,
        keyword: this.keywordTemp,
        deviceAttribute: this.deviceAttribute
      };
      this.$emit("onSearch", searchConditions);
    },
    
    // 导出方法：收集所有筛选条件并传给父组件
    exportAction() {
      const exportConditions = {
        model: this.deviceModel,
        deviceSn: this.deviceSN,
        deviceStatus: this.deviceStatus,
        faultOrderStatus: this.faultOrderStatus,
        outboundPersonId: this.responsiblePerson,
        outboundHospitalId: this.organization,
        expirationStatus: this.flowCard,
        deviceNature: this.deviceNature,
        keyword: this.keywordTemp
      };
      this.$emit("onExport", exportConditions);
    },
  },
};
</script>

<style lang="scss" scoped>
.filter-bar {
  padding: rem(20) rem(0);
  
  // 小屏：垂直布局，筛选条件每个一行，按钮独立一行
  @media (max-width: 1200px) {
    display: flex;
    flex-direction: column;
    gap: rem(20);
    
    .filter-bar-selects {
      display: flex;
      flex-direction: column;
      gap: rem(16);
      width: 100%;
    }
    
    .filter-bar-buttons {
      display: flex;
      flex-wrap: wrap;
      gap: rem(10);
      width: 100%;
    }
  }
  
  // 大屏：水平布局，筛选条件在左，按钮在右
  @media (min-width: 1201px) {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: rem(20);
    
    .filter-bar-selects {
      display: flex;
      flex-wrap: wrap;
      gap: rem(16);
      flex: 1;
    }
    
    .filter-bar-buttons {
      display: flex;
      flex-wrap: wrap;
      gap: rem(10);
      flex-shrink: 0;
    }
  }

  &-select {
    display: flex;
    align-items: center;
    gap: rem(8);
    
    span {
      font-size: rem(14);
      color: #666;
      white-space: nowrap;
      width: rem(60);
      text-align: right;
    }
    
    ::v-deep .el-select {
      width: rem(120);
    }
    
    ::v-deep .el-cascader {
      width: rem(120);
    }
    
    ::v-deep .el-input {
      width: rem(120);
    }
  }

  &-button {
    color: white;
    background-color: #325fac;
    font-size: rem(14);
    border-radius: rem(4);
    width: rem(88);
    height: rem(32);
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    
    &:hover {
      background-color: rgb(91, 127, 189);
    }
    
    &:active {
      background-color: rgb(45, 86, 155);
    }
  }
}
</style>

<style lang="scss">
.el-range-editor--mini .el-range__icon {
  margin-top: rem(5);
}

.el-range-editor--mini.el-input__inner {
  border: transparent;
}

.el-range-editor--mini .el-range-input {
  font-size: rem(16);
  margin-top: rem(2);
}

.el-range-editor--mini .el-range-separator {
  font-size: rem(16);
  margin-top: rem(2);
}
</style>
